export const FLOW_NAME = "driver-analysis-continous";
export type FLOW_TYPE = "driver-analysis-continous";

export const INPUT_DATA = "input-data";

export const Y_COLUMNS = "y-columns"; // For Continous Y
export const OUTCOME_COLUMN_NAME = "outcome-column";

export const TIME_VARIABLE = "time-column";
export const GROUPING_VARIABLES = "grouping-columns";
export const LABEL_VARIABLES = "label-columns";
export const ENTITY_VARIABLES = "entity-columns";


